<div class="wrapper mb-5">
    <div class="row align-items-center m-0" style="padding: 10px;">
        <img class="p-2" src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3">Veículos</span>
        <button class="action-button ml-2 my-1" (click)="goToCreate()">Novo Veículo</button>
    </div>
    <div class="component-box container-fluid">
        <div class="container-fluid pt-4">
            <div class="row">
                <div class="col-md-6 col-sm-12">
                    <!-- <ul class="options-cadastro pl-0 float-left">
                        <li>
                            <div (click)="exportExcel()" class="list-select ml-2 my-1">
                                <button _ngcontent-khv-c20="" class="list-select"  type="button">
                                    <span>Exportar Excel</span>
                                </button>
                            </div>
                        </li>
                        <li>
                            <div (click)="exportPdf()" class="list-select ml-2 my-1">
                                <button _ngcontent-khv-c20="" class="list-select"  type="button">
                                    <span>Exportar PDF</span>
                                </button>
                            </div>
                        </li>
                    </ul> -->
                </div>
                <div class="col-md-6 text-right">
                    <ul class="options-cadastro">
                        <li>
                            <div *ngIf="filterOn" (click)="deleteFilter()" class="list-select ml-2 my-1">
                                <button class="list-select-delete" type="button">
                                    Apagar filtro
                                </button>
                            </div>
                        </li>
                        <li>
                            <div (click)="showFilter(modalfilter)" class="list-select ml-2 my-1">
                                <button class="list-select" type="button">
                                    <span *ngIf="!filterOn"><img src="assets/icons/filter.svg" style="height: 15px;">
                                        Aplicar filtro</span>
                                    <span *ngIf="filterOn"><img src="assets/icons/filter-purple.svg"
                                            style="height: 15px;"> Alterar filtro</span>
                                </button>
                            </div>
                        </li>
                        <li>
                            <div class="list-filter-show-item ml-2 my-1">
                                Mostrar:
                                <select (change)="showItemChanged($event.target.value)"
                                    class="ng-untouched ng-pristine ng-valid">
                                    <option _ selected="" value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="table-overflow">
                <div class="table-responsive visible-table">
                    <table class="list-table table table-striped" id="dataTable" width="100%" cellspacing="0">
                        <thead>
                            <th>Apelido</th>
                            <th>Placa</th>
                            <th>Modelo</th>
                            <th>Marca</th>
                            <th>Combustível</th>
                            <th>Situação</th>
                        </thead>
                        <tbody class="list-table-row">
                            <tr
                                *ngFor=" let item of vehiclesList | paginate : { itemsPerPage: showItem, currentPage: currentPage, totalItems: totalItems, id: 'vehicles' }">
                                <td>{{ item.nickName }}</td>
                                <td>{{ item.registrationPlate }}</td>
                                <td>{{ item.model }}</td>
                                <td>{{ item.manufacturer }}</td>
                                <td>{{ getFuelDescription(item.fuelId) }}</td>
                                <td>{{ item.isActive ? 'Ativo' : 'Desativado' }}</td>
                                <td>
                                    <div ngbDropdown class="d-inline-block menu-option custom-context-menu-container" placement="left">
                                        <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle>
                                            <img src="assets/icons/menu.png" />
                                        </button>
                                        <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                            <section class="custom-context-menu">
                                                <div ngbDropdownItem (click)="vehiclesEdit(item.vehicleGuid)">
                                                    <img src="assets/icons/pencil-purple.png" class="mr-2" />
                                                    Editar veículo
                                                </div>
                                                <div ngbDropdownItem (click)="vehiclesConductors(item.vehicleGuid)">
                                                    <img src="assets/icons/pencil-purple.png" class="mr-2" />
                                                    Condutores
                                                </div>
                                                <div ngbDropdownItem (click)="vehiclesPhysicalCard(item.vehicleGuid)" *ngIf="item.cardId == null || item.definitiveBlock">
                                                    <img src="assets/icons/linkCard.png" style="width: 18px;" class="mr-2" />
                                                    Vincular Cartão
                                                </div>
                                                <div ngbDropdownItem (click)="showModalVerCartao(modalVerCartao,item)" *ngIf="item.cardId != null">
                                                    <img src="assets/icons/seeCard-bold.png" style="width: 18px;" class="mr-2" />
                                                    Ver Cartão
                                                </div>
                                                <div ngbDropdownItem (click)="showModalTrocarSenhaCartao(modalTrocarSenhaCartao,item)" *ngIf="item.cardId != null" >
                                                    <img src="assets/icons/resetPassword.png" class="mr-2" style="width: 18px;"/>Trocar Senha
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div *ngIf="!vehiclesList || vehiclesList == [] || vehiclesList.length == 0" class="text-center">
                        Nenhum registro carregado. Aplique o filtro para retornar a lista com registros
                    </div>

                    <div class="page-custom mt-2">
                        <pagination-controls id="vehicles" (pageChange)="pagevehicles($event)" responsive="true"
                            previousLabel="" nextLabel=""></pagination-controls>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--Modal do Filtro-->
<ng-template #modalfilter let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Aplicar filtro</h5>
        </div>
    </div>
    <div class="row col-12 clean-modal-content">
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-label>Apelido</mat-label>
                    <input [(ngModel)]="filters.nickName" matInput type="text">
                </mat-form-field>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-label>Placa</mat-label>
                    <input [(ngModel)]="filters.registrationPlate" matInput type="text">
                </mat-form-field>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-label>Modelo</mat-label>
                    <input [(ngModel)]="filters.model" matInput type="text">
                </mat-form-field>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-label>Marca</mat-label>
                    <input [(ngModel)]="filters.manufacturer" matInput type="text">
                </mat-form-field>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-label>Tipo de combustivel</mat-label>
                    <mat-select [(ngModel)]="filters.fuel">
                        <mat-option value="">Nenhum</mat-option>
                        <mat-option *ngFor="let itemFuels of fuelsList" [value]="itemFuels.id">
                            {{itemFuels.description }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button custom-filter-button-just" type="button"
            (click)="applyFilter();modal.dismiss('Close click')" ngbAutofocus>
            Aplicar
        </button>
    </div>
</ng-template>

<!-- Modal Selecao Vinculacao do cartao -->
<ng-template #modalTrocarSenhaCartao let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Trocar Senha</h5>
            <p class="clean-modal-subtitle">
                Troque a senha do cartão do veículo
            </p>
        </div>
    </div>
    <div class="row px-4 d-flex justify-content-end ">
        <p class="col-12 clean-modal-subtitle" style="font-size: 18px;">
            Você está gerando uma nova senha para o cartão de final {{ '**** **** **** ' + vehicleSelected.lastDigits}}
        </p>
        <div class="col-12 custom-filter-input-container">
            <form [formGroup]="cardPasswordResetFormGroup">
                <div class="row p-4 d-flex justify-content-center">
                    <div class="col-6 text-center">
                        <mat-form-field >
                            <mat-label>Nova senha do cartão</mat-label>
                            <input matInput formControlName="newCardPin" type="password" maxlength="4" onlyNumber>
                        </mat-form-field>
                        <mat-error *ngIf="(cardPasswordResetFormGroup.get('newCardPin').invalid && (cardPasswordResetFormGroup.get('newCardPin').dirty || cardPasswordResetFormGroup.get('newCardPin').touched)) && cardPasswordResetFormGroup.get('newCardPin').errors.required">
                            A nova senha do cartão é obrigatória!
                        </mat-error>
                        <mat-error *ngIf="(cardPasswordResetFormGroup.get('newCardPin').invalid && (cardPasswordResetFormGroup.get('newCardPin').dirty || cardPasswordResetFormGroup.get('newCardPin').touched)) && (cardPasswordResetFormGroup.get('newCardPin').errors.minlength && cardPasswordResetFormGroup.get('newCardPin').errors.maxlength)">
                            A nova senha deve conter 4 dígitos
                        </mat-error>
                    </div>
                    <div class="col-6 text-center">
                        <mat-form-field>
                            <mat-label>Confirmação da senha</mat-label>
                            <input matInput formControlName="confirmNewCardPin" type="password" maxlength="4" onlyNumber>
                        </mat-form-field>
                        <mat-error *ngIf="(cardPasswordResetFormGroup.get('confirmNewCardPin').invalid && (cardPasswordResetFormGroup.get('confirmNewCardPin').dirty || cardPasswordResetFormGroup.get('confirmNewCardPin').touched)) && cardPasswordResetFormGroup.get('confirmNewCardPin').errors.required">
                            A senha de confirmação é obrigatória
                        </mat-error>
                        <mat-error *ngIf="(cardPasswordResetFormGroup.get('confirmNewCardPin').invalid && (cardPasswordResetFormGroup.get('confirmNewCardPin').dirty || cardPasswordResetFormGroup.get('confirmNewCardPin').touched)) && cardPasswordResetFormGroup.get('confirmNewCardPin').errors.mustMatch">
                            As senhas devem coincidir
                        </mat-error>
                    </div>
                </div>
            </form>
        </div>
    </div>

    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" (click)="modal.dismiss('Close click')" ngbAutofocus>
            Cancelar
        </button>
        <!-- managerPassword.value -->
        <button class="custom-modal-button" type="button" (click)="trocarSenhaCartao()">
            Gerar Senha
        </button>
    </div>
</ng-template>

<!-- Modal Selecao Vinculacao do cartao -->
<ng-template #modalVerCartao let-modal>
    <div class="col-12 pb-0 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Visualizar Cartão</h5>
            <p class="clean-modal-subtitle">
                Você está visualizando o cartão
            </p>
        </div>
    </div>
    <div class="row px-4 d-flex justify-content-center ">
        <p class="col-12 clean-modal-subtitle" style="font-size: 18px;" *ngIf="vehicleSelected?.lastDigits != null" >
            Número do cartão: {{ '**** **** **** ' + vehicleSelected.lastDigits}}
        <br>
        </p>
        <div class="col-10 custom-filter-input-container" *ngIf="!vehicleSelected.definitiveBlock && !vehicleSelected.temporaryBlock">
            <p class="clean-modal-subtitle">
                <b>Deseja bloquear este cartão?</b>
            </p>
            <div class="row justify-content-center">
                <div  class="col-6">
                    <div  class="component-box container-fluid mb-2 mt-2 mr-4 clickable border-button" (click)="showModalConfimacao(modalConfirmacao, true)">
                        <div class="container-fluid row mx-0 p-3">
                            <div class="col-md-12 align-items-center pt-2 text-center">
                                <div class="col-md-12">
                                    <h5 class="m-0">Bloqueio Temporário</h5>
                                </div>
                            </div>
                            <div class="col align-self-center pb-2">
                                <div class="text-center">
                                    <p>
                                        Após esse bloqueio você ainda poderá desbloquear esse cartão e utilizá-lo novamente.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="component-box container-fluid mb-0 mt-2 mr-4 clickable border-button"  (click)="showModalConfimacao(modalConfirmacao)">
                        <div class="container-fluid row mx-0 p-3">
                            <div class="col-md-12 align-items-center pt-2 text-center">
                                <div class="col-md-12">
                                    <h5 class="m-0">Bloqueio Definitivo</h5>
                                </div>
                            </div>
                            <div class="col align-self-center pb-2">
                                <div class="text-center">
                                    <p>
                                        Após esse bloqueio não será mais possível utilizar esse cartão. Você deverá vincular um novo cartão para esse veículo.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-6 custom-filter-input-container" *ngIf="vehicleSelected.temporaryBlock && !vehicleSelected.definitiveBlock">
            <p class="clean-modal-subtitle">
                <b>Deseja desbloquear este cartão?</b>
            </p>
            <div  class="component-box container-fluid mb-2 mt-2 mr-4 clickable border-button" (click)="desbloquearCartao()">
                <div class="container-fluid row mx-0 p-3">
                    <div class="col-md-12 align-items-center pt-2 text-center">
                        <div class="col-md-12">
                            <h5 class="m-0">Desbloquear Cartão</h5>
                        </div>
                    </div>
                    <div class="col align-self-center pb-2">
                        <div class="text-center">
                            <p>
                                Desbloqueie o cartão do veículo.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-6 custom-filter-input-container" *ngIf="vehicleSelected.definitiveBlock">
            <div  class="component-box container-fluid mb-2  mt-2 mr-4">
                <div class="container-fluid row mx-0 p-3">
                    <div class="col-md-12 align-items-center pt-2 text-center">
                        <div class="col-md-12">
                            <h5 class="m-0">Cartão Bloqueado</h5>
                        </div>
                    </div>
                    <div class="col align-self-center pb-2">
                        <div class="text-center">
                            <p>
                                Este cartão está bloqueado de forma definitiva.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" (click)="modal.dismiss('Close click')">
            Fechar
        </button>
    </div>
</ng-template>

<!-- Modal Confirmação -->
<ng-template #modalConfirmacao let-modal>
    <div class="col-12 pb-0 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Confirmar Bloqueio do Cartão </h5>
        </div>
    </div>
    <div class="row p-4 d-flex justify-content-center ">
        <div class="col-md-12 align-items-center pt-2 text-center">
            <p class="m-0">
                Confirma o bloqueio do cartão
            </p>
            <p class="m-0" *ngIf="vehicleSelected?.lastDigits != null">
                {{ '**** **** **** ' + vehicleSelected.lastDigits}}?
            </p>
            <div *ngIf="!temp">
                <p class="m-0 mt-4">Para confirmar o bloqueio digite sua senha de acesso</p>
                <mat-form-field class="w-75">
                    <mat-label>Senha</mat-label>
                    <input matInput placeholder="Digite sua senha" [(ngModel)]="cardPassword" name="password" type="password" minlength="6" maxlength="10" onlyNumber>
                </mat-form-field>
                <mat-error *ngIf="cardPassword === '' ">
                    A senha é obrigatória!
                </mat-error>
            </div>
        </div>
    </div>

    <div class="col-12 p-2 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" (click)="modalService.dismissAll()" ngbAutofocus>
            Cancelar
        </button>
        <button class="custom-filter-button mr-2" (click)="bloquearCartao(temp)">
            Confirmar
        </button>
    </div>
</ng-template>
